/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegistrationStart
 */
export interface RegistrationStart {
    /**
     * 
     * @type {string}
     * @memberof RegistrationStart
     */
    username: string;
}

/**
 * Check if a given object implements the RegistrationStart interface.
 */
export function instanceOfRegistrationStart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function RegistrationStartFromJSON(json: any): RegistrationStart {
    return RegistrationStartFromJSONTyped(json, false);
}

export function RegistrationStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationStart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function RegistrationStartToJSON(value?: RegistrationStart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
    };
}

